import { render, staticRenderFns } from "./MyCollection.vue?vue&type=template&id=6cca4adb&"
import script from "./MyCollection.vue?vue&type=script&lang=ts&"
export * from "./MyCollection.vue?vue&type=script&lang=ts&"
import style0 from "./MyCollection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports